import { useTranslation, Trans } from 'react-i18next';

import { Text, Button, Modal } from '@hotjar/hotsauce';
import type { OrganizationModel } from '@hotjar/webapp/domains/sso/model';

interface Props {
  isLoading: boolean;
  organization: OrganizationModel;
  onDismiss: () => void;
  onDisconnect: () => void;
}

export const ConfirmDisconnectionModal = ({
  organization,
  onDismiss,
  onDisconnect,
  isLoading,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  const nextSteps: Array<string> = [
    'still-there',
    'rejoin',
    'separate-account',
    'favorites',
    'no-account',
  ];

  return (
    <>
      <Modal.Header title={t('common:settings.sso.disconnect-modal.title')} />

      <Modal.Body>
        <Text as="p">
          <Trans
            i18nKey="common:settings.sso.disconnect-modal.subtitle"
            values={{ name: organization.name }}
          >
            <strong>{organization.name}</strong>
          </Trans>
        </Text>

        <Text as="p" textType="subtitle2">
          <strong>{t('common:settings.sso.disconnect-modal.content.next')}</strong>
        </Text>

        <ul>
          {nextSteps.map((step) => (
            <Text key={step} as="li" textType="body2">
              {t(`common:settings.sso.disconnect-modal.content.${step}`)}
            </Text>
          ))}
        </ul>
      </Modal.Body>

      <Modal.Footer>
        <Button kind="ghost" isDisabled={isLoading} onClick={onDismiss}>
          {t('common:settings.sso.disconnect-modal.content.cancel')}
        </Button>

        <Button kind="danger" icon="trash" isLoading={isLoading} onClick={onDisconnect}>
          {t('common:settings.sso.disconnect-modal.content.confirm')}
        </Button>
      </Modal.Footer>
    </>
  );
};
